import { chakra, Flex, FlexProps } from '@chakra-ui/react';
import { StatsQuery, useStatsQuery } from 'generated/graphql';
import Stat, { Props as StatProps } from './Stat';

interface StatConfig extends Omit<StatProps, 'number' | 'loading'> {
  key: keyof StatsQuery['stats'];
}

const stats: StatConfig[] = [
  { icon: 'signature', key: 'contractCount', desc: 'Your current contracts' },
  { icon: 'signature-slash', key: 'expiringContractCount', desc: 'Contracts expiring this month' },
  { icon: 'users', key: 'clientCount', desc: 'Your current clients' },
  { icon: 'door-open', key: 'availableSuitesCount', desc: 'Available suites in all locations' },
];

function Stats(props: FlexProps) {
  const { data, loading } = useStatsQuery();

  return (
    <Flex gap={4} justifyContent="space-between" {...props}>
      {stats.map(({ key, ...stat }) => (
        <Stat key={stat.icon} {...stat} loading={loading} number={data?.stats[key] || 0} />
      ))}
    </Flex>
  );
}

export default chakra(Stats);
